import type { Scoop } from "./types";

export const scoops: Scoop[] = [
  {
    id: "s260910-01",
    code: "档案号 S-260910-01",
    title: "网传某连锁餐饮后厨使用过期食材，多段实拍与内部排班表流出",
    summary:
      "九段拍摄于凌晨解冻间与冷藏柜的实拍视频陆续流出，配合内部排班表与进货单据，指向同一门店存在过期食材二次贴标的情况。属地市场监管部门已到场核查。",
    category: "社会民生",
    tags: ["实拍视频", "内部单据", "监管核查"],
    verdict: "confirmed",
    credibility: 91,
    sources: 7,
    heat: 96,
    date: "2026-09-08",
    updated: "2026-09-10 09:20",
    readMinutes: 6,
    author: "拾真社调查组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20commercial%20kitchen%20refrigerator%20and%20inspection%20clipboard%20on%20stainless%20steel%20counter%2C%20soft%20clinical%20light%2C%20muted%20beige%20tones%2C%20investigative%20evidence%20concept%2C%20clean%20editorial%20composition&width=800&height=520&seq=scoop-cover-01&orientation=landscape",
    body: [
      "从九月八日凌晨开始，一段拍摄于某连锁餐饮品牌门店后厨的视频在多个社交平台扩散。视频中，一名员工将冷藏柜内已标注日期的食材外包装撕下，重新贴上当日日期的标签。拍摄者声音在此后出现的另外几段视频中被反复确认，指向同一间解冻间与同一台冷藏柜。",
      "拾真社在收到首批投稿后，先对视频元数据做了比对。九段材料的拍摄设备型号一致，画面中的不锈钢台面划痕、墙面排风口位置、门口张贴的值日表均能相互对应，可以判断为同一物理空间在不同日期的连续拍摄，而非网络拼接。",
      "我们把三段视频的关键帧与门店公示的营业资质进行了交叉核对，门店编号与投稿人提供的工资单抬头完全一致。随后出现的内部排班表进一步佐证了时间线：视频出现当日，解冻间的早班人员与排班表登记的姓名缩写吻合。",
      "关于食材是否真的过期，我们目前掌握的证据是进货单据与标签日期的时间差。单据显示这批冷冻品到货日期为八月二十九日，而其自身保质期为七天；视频拍摄日期为九月六日，标签却显示为当日分装。这一点是整条证据链中最关键、也最需要第三方复检的部分。",
      "属地市场监管部门在九月九日下午回应称已到场核查并调取监控，后续处理结果将对外公布。在官方结论落地前，我们维持证据层面的判断：核心事实成立，具体涉事范围与责任划分仍以通报为准。",
    ],
    evidence: [
      {
        kind: "视频",
        title: "后厨解冻间连续实拍（9 段）",
        note: "设备型号、台面划痕、墙面设施可交叉对应，判定为同一空间连续拍摄。",
        status: "verified",
      },
      {
        kind: "单据",
        title: "冷冻品进货单据与分装标签",
        note: "到货日期与标签日期存在时间差，需第三方复检确认是否过期。",
        status: "verified",
      },
      {
        kind: "文件",
        title: "门店内部排班表",
        note: "排班人员姓名缩写与视频中出现人员一致。",
        status: "verified",
      },
      {
        kind: "公开记录",
        title: "属地市场监管部门回应",
        note: "已到场核查并调取监控，正式结论待通报。",
        status: "pending",
      },
    ],
    timeline: [
      { time: "09-06 03:40", text: "首段解冻间视频被拍摄。" },
      { time: "09-08 01:10", text: "素材在社交平台开始扩散，出现多个转发版本。" },
      { time: "09-08 15:00", text: "拾真社收到投稿，启动来源与元数据比对。" },
      { time: "09-09 17:30", text: "属地监管部门回应已到场核查。" },
      { time: "09-10 09:20", text: "本档案更新可信度评分至 91，维持『已实锤』判断。" },
    ],
    related: ["s260904-03", "s260826-06"],
  },
  {
    id: "s260909-02",
    code: "档案号 S-260909-02",
    title: "网传某科技公司大规模裁员名单截图，被指与内部系统格式不符",
    summary:
      "一张标注为内部员工名单的截图在职场社群流传，名单含工号、部门与入职日期。我们比对后发现其字段顺序与该公司公开系统导出的格式存在明显差异。",
    category: "科技前沿",
    tags: ["截图存疑", "格式比对", "企业回应"],
    verdict: "partial",
    credibility: 58,
    sources: 4,
    heat: 74,
    date: "2026-09-09",
    updated: "2026-09-09 20:05",
    readMinutes: 5,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20laptop%20screen%20with%20blurred%20spreadsheet%20rows%20next%20to%20printed%20employee%20list%2C%20soft%20desk%20lamp%20light%2C%20cream%20and%20amber%20palette%2C%20data%20verification%20concept%2C%20minimal%20clean%20composition&width=800&height=520&seq=scoop-cover-02&orientation=landscape",
    body: [
      "名单截图最早出现在一个职场交流群，随后被搬运到多个平台。截图以表格形式列出员工的工号、所属部门、入职日期与岗位级别，右上角带有疑似内部系统的页签。",
      "我们找到了该公司对外公开招聘流程中使用的同一系统截图作为参照。参照图中，列顺序为『工号、部门、岗位、入职日期』，而流传名单的顺序为『工号、入职日期、部门、岗位』。列顺序这类细节通常由系统模板统一决定，很难因人手工修改而产生变化。",
      "不过，名单中部分工号前缀确实与该公司现行编码规则一致，部门名称也与公开的组织架构基本吻合。这说明制作者至少掌握了一部分真实信息，或名单系基于真实组织信息二次加工。",
      "该公司品牌部门在回应中表示，网传名单并非官方文件，公司人员调整以内部通知为准，不便披露具体数字。综合来看，我们将其判定为『部分属实』：名单形式存在明显伪造痕迹，但不排除其中部分岗位信息来源于真实变动。",
    ],
    evidence: [
      {
        kind: "截图",
        title: "流传的员工名单截图",
        note: "列顺序与公司系统模板不符，存在二次编辑痕迹。",
        status: "refuted",
      },
      {
        kind: "截图",
        title: "系统模板参照图",
        note: "来自公开可查的招聘流程页面，用于格式比对。",
        status: "verified",
      },
      {
        kind: "公开记录",
        title: "涉事公司品牌部门回应",
        note: "否认名单为官方文件，未披露调整规模。",
        status: "verified",
      },
    ],
    timeline: [
      { time: "09-08 22:00", text: "名单截图在职场社群首次出现。" },
      { time: "09-09 11:20", text: "多个平台出现搬运版本，标题逐步夸大。" },
      { time: "09-09 18:40", text: "涉事公司回应网传名单非官方文件。" },
      { time: "09-09 20:05", text: "本档案评级为『部分属实』，可信度 58。" },
    ],
    related: ["s260910-01", "s260903-04"],
  },
  {
    id: "s260907-03",
    code: "档案号 S-260907-03",
    title: "网传某地街头“扫码送礼品”采集人脸信息，警方通报为操作违规",
    summary:
      "短视频显示摊位要求路人扫码后对准镜头停留，被质疑采集人脸。警方通报确认存在违规操作，但未发现有信息外传的证据。",
    category: "社会民生",
    tags: ["人脸信息", "警方通报", "隐私"],
    verdict: "partial",
    credibility: 72,
    sources: 5,
    heat: 68,
    date: "2026-09-07",
    updated: "2026-09-08 10:15",
    readMinutes: 4,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20photo%20of%20street%20promotion%20booth%20with%20smartphone%20on%20tripod%20and%20gift%20boxes%2C%20soft%20afternoon%20light%2C%20muted%20beige%20and%20olive%20tones%2C%20privacy%20investigation%20concept%2C%20clean%20editorial%20style&width=800&height=520&seq=scoop-cover-03&orientation=landscape",
    body: [
      "视频拍摄于一处商业街的推广摊位。画面中，工作人员指引路人用手机扫描立牌上的码，随后要求对方『看着镜头停三秒』。由于镜头停留环节被完整拍下，视频迅速被解读为采集人脸信息。",
      "我们联系到发布者，拿到了同一摊位在不同日期的两段素材。两段素材中，立牌上的活动名称与赠送礼品一致，可以确认是同一场推广活动。",
      "警方通报显示，该推广确实存在未经告知收集面部影像的操作，相关设备已被暂扣，暂未发现信息被外传。这意味着『违规收集』这一定性成立，但『信息已经流向黑产』的延伸说法缺乏证据支撑。",
      "因此本档案评级为『部分属实』：违规操作属实，外传传闻未经证实，请勿在此基础上继续二次演绎。",
    ],
    evidence: [
      {
        kind: "视频",
        title: "推广摊位两段现场素材",
        note: "活动名称与礼品一致，可确认为同一场推广。",
        status: "verified",
      },
      {
        kind: "公开记录",
        title: "警方通报",
        note: "确认违规收集面部影像，设备暂扣，未发现外传。",
        status: "verified",
      },
      {
        kind: "口述",
        title: "『信息已流向黑产』说法",
        note: "无任何可信来源支撑，属延伸演绎。",
        status: "refuted",
      },
    ],
    timeline: [
      { time: "09-05 16:00", text: "现场视频被拍摄并上传。" },
      { time: "09-06 09:00", text: "『人脸被售卖』的延伸说法开始扩散。" },
      { time: "09-07 19:30", text: "警方发布通报，说明核查进展。" },
      { time: "09-08 10:15", text: "本档案更新评级为『部分属实』，可信度 72。" },
    ],
    related: ["s260909-02", "s260901-05"],
  },
  {
    id: "s260904-03",
    code: "档案号 S-260904-03",
    title: "某公益活动善款去向遭质疑，公开账目与票据自证清晰",
    summary:
      "有账号发文称某助学活动善款去向不明。我们核对了主办方公开的收支表、受助学校签收单与银行回单，账目项目之间可以逐笔对应。",
    category: "社会民生",
    tags: ["善款", "账目核对", "票据"],
    verdict: "refuted",
    credibility: 86,
    sources: 6,
    heat: 52,
    date: "2026-09-04",
    updated: "2026-09-06 14:40",
    readMinutes: 7,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20open%20accounting%20ledger%20with%20receipts%20and%20calculator%20on%20wooden%20table%2C%20soft%20window%20light%2C%20cream%20and%20gold%20tones%2C%20charity%20fund%20audit%20concept%2C%20clean%20minimal%20composition&width=800&height=520&seq=scoop-cover-04&orientation=landscape",
    body: [
      "质疑文章的核心论点是：活动募集金额与实际支出金额差距较大，且未公布完整票据。文章配了部分截图，但截图被裁掉了表头。",
      "我们找到了主办方在活动期间持续更新的公开账目。完整表格中，募集总额、执行成本、结余三项分别列示，结余部分明确标注为『结转下一期』，并向监管备案。",
      "随后我们逐笔核对了大额支出：受助学校的签收单、采购发票与银行回单在金额、日期上均能对应，未发现无法解释的缺口。质疑文章所称的『差距』，实际来自裁掉表头后只看两列数字造成的误读。",
      "综合原始凭证，本档案判定为『已辟谣』：所谓去向不明并不成立，质疑文章存在明显的信息截取问题。",
    ],
    evidence: [
      {
        kind: "文件",
        title: "活动公开收支表（完整版）",
        note: "含募集、执行、结余三列，结余标注为结转并备案。",
        status: "verified",
      },
      {
        kind: "单据",
        title: "受助学校签收单与采购发票",
        note: "与银行回单金额、日期逐笔对应。",
        status: "verified",
      },
      {
        kind: "截图",
        title: "质疑文章的截取图",
        note: "裁掉表头，导致数字被误读。",
        status: "refuted",
      },
    ],
    timeline: [
      { time: "09-02 10:00", text: "质疑文章发布，配图被裁切。" },
      { time: "09-04 09:00", text: "拾真社启动账目比对。" },
      { time: "09-05 16:20", text: "主办方补充公开完整票据。" },
      { time: "09-06 14:40", text: "本档案判定『已辟谣』，可信度 86。" },
    ],
    related: ["s260910-01", "s260901-05"],
  },
  {
    id: "s260903-04",
    code: "档案号 S-260903-04",
    title: "某地“地铁将涨价”消息流传，官方尚未发布听证公告",
    summary:
      "一张疑似内部通知的图片称本月底调整票价。检索公开渠道未发现听证公告，图片中的落款单位名称也与现有机构表述不符。",
    category: "社会民生",
    tags: ["票价", "假通知", "官方渠道"],
    verdict: "unverified",
    credibility: 34,
    sources: 3,
    heat: 61,
    date: "2026-09-03",
    updated: "2026-09-05 11:00",
    readMinutes: 4,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20subway%20fare%20gate%20and%20printed%20notice%20paper%20in%20soft%20light%2C%20muted%20cream%20and%20olive%20palette%2C%20public%20transit%20notice%20verification%20concept%2C%20clean%20minimal%20composition&width=800&height=520&seq=scoop-cover-05&orientation=landscape",
    body: [
      "流传图片以红头文件形式呈现，标题为『关于调整轨道交通票价的内部通知』，但正文用语与常见公告体例有差异，落款单位名称缺少规范后缀。",
      "我们在公开渠道检索了该机构近三个月的公告，未发现任何与票价调整相关的听证或征求意见信息。按照惯例，票价调整通常会先经过公开程序。",
      "由于尚无官方口径，我们既不能认定图片为真，也无法排除后续确有调整。本档案暂列『待求证』，一旦官方发布信息将立即更新。",
      "提醒：在官方渠道发布公告前，请勿依据该图片调整出行或消费安排。",
    ],
    evidence: [
      {
        kind: "截图",
        title: "疑似内部通知图片",
        note: "落款单位名称缺少规范后缀，体例与常见公告不同。",
        status: "pending",
      },
      {
        kind: "公开记录",
        title: "公开渠道公告检索",
        note: "近三个月无票价调整相关听证或征求意见信息。",
        status: "verified",
      },
    ],
    timeline: [
      { time: "09-02 20:00", text: "疑似通知图片在本地社群出现。" },
      { time: "09-03 10:30", text: "多平台转发并附加涨价幅度等未证实细节。" },
      { time: "09-05 11:00", text: "公开渠道仍未检索到对应公告，维持『待求证』。" },
    ],
    related: ["s260909-02", "s260907-03"],
  },
  {
    id: "s260901-05",
    code: "档案号 S-260901-05",
    title: "网传某品牌食品检测超标，实验室复检结果与原说法存在量级差异",
    summary:
      "一份标称第三方检测的报告在社群流传。我们联系到具备资质的实验室对同批次留样复检，结果虽高于内控标准，但远低于网传数值。",
    category: "健康生活",
    tags: ["检测报告", "复检", "量级差异"],
    verdict: "partial",
    credibility: 66,
    sources: 5,
    heat: 57,
    date: "2026-09-01",
    updated: "2026-09-04 16:10",
    readMinutes: 6,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20laboratory%20beakers%20and%20printed%20test%20report%20on%20clean%20bench%2C%20soft%20light%2C%20cream%20and%20amber%20tones%2C%20food%20testing%20verification%20concept%2C%20clean%20minimal%20composition&width=800&height=520&seq=scoop-cover-06&orientation=landscape",
    body: [
      "流传报告的关键数值被大量转发，但报告本身缺少完整的样品编号与仪器信息，无法直接核验来源。",
      "我们联系了一家具备资质的实验室，对该批次留样进行复检。复检结果显示，其中一项指标确实高于企业内控标准，但仅超出微量，与网传数值不在同一量级。",
      "需要说明的是，内控标准通常严于强制性标准，超出内控并不等同于不符合安全要求。因此网传『严重超标』的表述缺乏依据。",
      "综合来看，本档案评级为『部分属实』：确实存在高于内控指标的情况，但网传数值与性质描述均被夸大。",
    ],
    evidence: [
      {
        kind: "文件",
        title: "流传的检测报告",
        note: "缺少样品编号与仪器信息，无法核验来源。",
        status: "refuted",
      },
      {
        kind: "文件",
        title: "同批次留样复检报告",
        note: "指标高于内控标准，但与网传数值量级不符。",
        status: "verified",
      },
      {
        kind: "口述",
        title: "实验室技术说明",
        note: "内控标准严于强制性标准，超出内控不等于不安全。",
        status: "verified",
      },
    ],
    timeline: [
      { time: "08-30 21:00", text: "疑似检测报告在社群流传。" },
      { time: "09-01 14:00", text: "拾真社委托实验室复检同批次留样。" },
      { time: "09-03 18:00", text: "复检报告出具，数值量级与网传不符。" },
      { time: "09-04 16:10", text: "本档案评级为『部分属实』，可信度 66。" },
    ],
    related: ["s260904-03", "s260910-01"],
  },
  {
    id: "s260826-06",
    code: "档案号 S-260826-06",
    title: "“某赛事赛程被临时调整”传闻，组委会未发布变更通知",
    summary:
      "一则截图称赛事因故调整开赛时间。我们核对了官方报名平台与场地租赁公开信息，均未出现变更，截图中的联系方式也无法接通。",
    category: "体育赛场",
    tags: ["赛程", "假截图", "官方渠道"],
    verdict: "refuted",
    credibility: 80,
    sources: 4,
    heat: 43,
    date: "2026-08-26",
    updated: "2026-08-28 09:30",
    readMinutes: 4,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20stadium%20seats%20and%20printed%20schedule%20sheet%20in%20soft%20daylight%2C%20muted%20cream%20and%20olive%20palette%2C%20sports%20event%20schedule%20verification%20concept%2C%20clean%20minimal%20composition&width=800&height=520&seq=scoop-cover-07&orientation=landscape",
    body: [
      "截图以赛事组委会名义发布，声称因场地原因调整开赛时间，并附了一个联系电话。",
      "我们在官方报名平台核对赛程，页面显示的场次时间与截图不一致，平台也没有任何变更公告。场地方面的公开租赁信息同样未显示冲突。",
      "此外，截图中的联系电话多次拨打均无法接通，号码归属地也与组委会所在地不符。综合判断，该截图并非官方发布，系伪造。",
      "本档案判定为『已辟谣』，请以官方报名平台公布信息为准。",
    ],
    evidence: [
      {
        kind: "截图",
        title: "疑似赛程调整通知",
        note: "联系电话无法接通，归属地与组委会所在地不符。",
        status: "refuted",
      },
      {
        kind: "公开记录",
        title: "官方报名平台赛程页",
        note: "场次时间与截图不一致，无变更公告。",
        status: "verified",
      },
    ],
    timeline: [
      { time: "08-25 19:00", text: "疑似调整通知在参赛社群流传。" },
      { time: "08-26 10:00", text: "官方平台赛程未变更。" },
      { time: "08-28 09:30", text: "本档案判定『已辟谣』，可信度 80。" },
    ],
    related: ["s260903-04", "s260909-02"],
  },
  {
    id: "s260822-07",
    code: "档案号 S-260822-07",
    title: "某平台“创作者分成比例下调”录音流出，平台确认方案仍在讨论",
    summary:
      "一段会议录音称平台将下调创作者分成。经声音比对与参会方确认，录音确实来自内部讨论会，但方案尚在讨论阶段，并未最终落地。",
    category: "科技前沿",
    tags: ["录音", "内部讨论", "方案未定"],
    verdict: "developing",
    credibility: 62,
    sources: 4,
    heat: 55,
    date: "2026-08-22",
    updated: "2026-09-02 15:00",
    readMinutes: 5,
    author: "拾真社调查组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20audio%20waveform%20on%20tablet%20screen%20and%20notebook%20on%20desk%2C%20soft%20lamp%20light%2C%20cream%20and%20amber%20palette%2C%20audio%20evidence%20analysis%20concept%2C%20clean%20minimal%20composition&width=800&height=520&seq=scoop-cover-08&orientation=landscape",
    body: [
      "录音时长约十一分钟，内容为一场内部会议中关于分成方案的讨论，涉及多个档位的调整设想。",
      "我们请专业人员做了声音特征比对。录音中的发言语调、口头习惯与一位公开露面的平台负责人在其他场合的表现接近，但环境噪音较重，无法做到同一性认定。",
      "平台方面向多位创作者确认，确实在讨论分成方案调整，但强调尚未定稿，也未确定执行时间。这与录音中『还在算模型』『下季度再定』的表述一致。",
      "由于方案仍在变化，本档案列为『持续跟进』。一旦有正式发布，我们会更新可信度与结论。",
    ],
    evidence: [
      {
        kind: "录音",
        title: "内部讨论会录音（约 11 分钟）",
        note: "环境噪音较重，声音比对接近但无法同一性认定。",
        status: "pending",
      },
      {
        kind: "口述",
        title: "参会方与创作者确认",
        note: "确认在讨论方案，但尚未定稿。",
        status: "verified",
      },
    ],
    timeline: [
      { time: "08-21 22:00", text: "录音在创作者社群流出。" },
      { time: "08-22 15:00", text: "多名创作者向平台求证方案进展。" },
      { time: "09-02 15:00", text: "平台确认方案仍在讨论，本档案改为『持续跟进』。" },
    ],
    related: ["s260909-02", "s260901-05"],
  },
  {
    id: "s260818-08",
    code: "档案号 S-260818-08",
    title: "网传某景区“闭园整修”致游客滞留，园区公告与实际开放时间不符",
    summary:
      "短视频显示大量游客在门口等候。我们核对了园区售票系统与现场公告牌，视频拍摄当日园区正常开放，滞留原因为临近闭园时段集中离场。",
    category: "文娱动态",
    tags: ["景区", "现场核实", "误读"],
    verdict: "refuted",
    credibility: 78,
    sources: 4,
    heat: 38,
    date: "2026-08-18",
    updated: "2026-08-20 12:00",
    readMinutes: 4,
    author: "拾真社求证组",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photo%20of%20scenic%20park%20entrance%20gate%20and%20visitor%20information%20board%20in%20soft%20evening%20light%2C%20muted%20cream%20and%20olive%20palette%2C%20tourism%20on%20site%20verification%20concept%2C%20clean%20minimal%20composition&width=800&height=520&seq=scoop-cover-09&orientation=landscape",
    body: [
      "视频标题称『景区突然闭园，几百人滞留』。画面中确有较多游客聚集在入口附近。",
      "我们调取了当日售票系统的公开数据，显示全天正常售票，入园人数处于常规水平，并没有紧急闭园记录。现场公告牌的照片也显示开放时间未调整。",
      "进一步比对视频中的光线与阴影，拍摄时间接近园区常规闭园时段。园区工作人员说明，这是集中离场时段的正常排队。",
      "本档案判定为『已辟谣』：所谓闭园滞留并不成立，视频存在明显的标题引导。",
    ],
    evidence: [
      {
        kind: "公开记录",
        title: "当日售票与入园数据",
        note: "全天正常售票，无紧急闭园记录。",
        status: "verified",
      },
      {
        kind: "照片",
        title: "现场公告牌",
        note: "开放时间与平日一致。",
        status: "verified",
      },
      {
        kind: "视频",
        title: "『闭园滞留』短视频",
        note: "光线判断拍摄于常规闭园时段，属集中离场。",
        status: "refuted",
      },
    ],
    timeline: [
      { time: "08-17 19:40", text: "短视频发布并配以『突然闭园』标题。" },
      { time: "08-18 11:00", text: "拾真社核对售票数据与现场公告。" },
      { time: "08-20 12:00", text: "本档案判定『已辟谣』，可信度 78。" },
    ],
    related: ["s260903-04", "s260826-06"],
  },
];